var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.render)?_c('div',{staticClass:"page-break-before"},[_c('highcharts',{staticClass:"chart",staticStyle:{"page-break-inside":"avoid","break-inside":"avoid"},attrs:{"constructor-type":'mapChart',"options":_vm.chartOptions}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }